import React, { useState, useEffect } from "react";
import { Table } from "react-bootstrap";
import { Pega_QTD_turmas } from "../../services/api";

const QTD_turmas = (props) => {
    const [data2, setData2] = useState([]);

    const unidades = [
        '', 'Bento Ribeiro', 'Madureira', 'Santa Cruz', 'Cascadura', 'Taquara',
        'Nilopolis', 'Nova Iguaçu', '', 'Seropédica', 'Barra', 'Campo Grande',
        'Centro de Excelência', 'Mangueira', 'Maricá', 'Ilha', 'Freguesia', 'Recreio'
    ];

    const styles = {
        bg2027: { backgroundColor: 'rgba(0, 123, 255, 0.05)' },
        bg2026: { backgroundColor: 'rgba(220, 53, 69, 0.05)' },
        bg2025: { backgroundColor: 'rgba(255, 193, 7, 0.05)' },
        header2027: { backgroundColor: '#007bff', color: 'white' },
        header2026: { backgroundColor: '#dc3545', color: 'white' },
        header2025: { backgroundColor: '#ffc107', color: '#000' }
    };

    const fetchData = async () => {
        try {
            const response = await Pega_QTD_turmas();
            const filteredData = response.filter(item => item.unidade !== '13'); // Exclui unidades com código '13'
            const sortedData = filteredData.sort((a, b) => {
                const nomeA = unidades[parseInt(a.unidade)] || "";
                const nomeB = unidades[parseInt(b.unidade)] || "";
                return nomeA.localeCompare(nomeB);
            });
            setData2(sortedData);
        } catch (error) {
            console.error("Erro ao buscar dados:", error);
        }
    };

    useEffect(() => {
        fetchData();
    }, [props.di, props.df]);

    // Renderiza o valor com setas. Cor da seta é forçada se o fundo for escuro (isTotal)
    const renderValue = (current, previous, isTotal = false) => {
        const cur = parseInt(current) || 0;
        const prev = parseInt(previous) || 0;

        // Se for total, a cor do texto base é definida pelo cabeçalho (geralmente branco)
        // Usamos cores mais claras para as setas no total para dar contraste
        const arrowUp = isTotal ? "#90ee90" : "green"; // Verde claro se fundo escuro
        const arrowDown = isTotal ? "#ffcccb" : "red"; // Vermelho claro se fundo escuro

        if (cur > prev) {
            return (
                <span className={isTotal ? "fw-bold" : "fw-bold text-success"}>
                    {cur} <small style={{ fontSize: '0.75em', color: isTotal ? arrowUp : 'inherit' }}>▲</small>
                </span>
            );
        } else if (cur < prev) {
            return (
                <span className={isTotal ? "fw-bold" : "fw-bold text-danger"}>
                    {cur} <small style={{ fontSize: '0.75em', color: isTotal ? arrowDown : 'inherit' }}>▼</small>
                </span>
            );
        }
        return <span className={isTotal ? "fw-bold" : ""}>{cur}</span>;
    };

    const totals = data2.reduce((acc, item) => {
        const categories = ['turmas', 'infantil', 'fund1', 'fund2', 'medio'];
        const years = ['25', '26', '27'];
        years.forEach(y => {
            categories.forEach(cat => {
                const key = `${cat}_${y}`;
                acc[key] = (acc[key] || 0) + (parseInt(item[key]) || 0);
            });
        });
        return acc;
    }, {});

    return (
        <div className="media mt-3">
            <h2 className="mb-2 text-center fw-light text-secondary">Quantitativo Turmas por Unidade</h2>
            <p className="mb-4 text-center text-muted small text-uppercase">Comparativo de evolução anual</p>

            <div className="table-responsive shadow-sm rounded border">
                <Table hover bordered size="sm" className="text-center align-middle bg-white m-0">
                    <thead className="table-dark text-nowrap">
                        <tr>
                            <th rowSpan="2" className="align-middle bg-dark">Unidade</th>
                            <th colSpan="5" style={styles.header2027}>Ano 2027 (vs 2026)</th>
                            <th colSpan="5" style={styles.header2026}>Ano 2026 (vs 2025)</th>
                            <th colSpan="5" style={styles.header2025}>Ano 2025</th>
                        </tr>
                        <tr className="small">
                            <th style={{ backgroundColor: '#0056b3', color: 'white' }}>Total</th>
                            <th className="bg-primary bg-opacity-10 text-dark">EI</th>
                            <th className="bg-primary bg-opacity-10 text-dark">EF I</th>
                            <th className="bg-primary bg-opacity-10 text-dark">EF II</th>
                            <th className="bg-primary bg-opacity-10 text-dark">E M</th>

                            <th style={{ backgroundColor: '#b02a37', color: 'white' }}>Total</th>
                            <th className="bg-danger bg-opacity-10 text-dark">EI</th>
                            <th className="bg-danger bg-opacity-10 text-dark">EF I</th>
                            <th className="bg-danger bg-opacity-10 text-dark">EF II</th>
                            <th className="bg-danger bg-opacity-10 text-dark">E M</th>

                            <th className="bg-warning text-dark fw-bold">Total</th>
                            <th className="bg-warning bg-opacity-10 text-dark">EI</th>
                            <th className="bg-warning bg-opacity-10 text-dark">EF I</th>
                            <th className="bg-warning bg-opacity-10 text-dark">EF II</th>
                            <th className="bg-warning bg-opacity-10 text-dark">E M</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data2.map((item, idx) => (
                            <tr key={idx}>
                                <td className="text-start fw-bold bg-light ps-3">
                                    {unidades[parseInt(item.unidade)] || `Unid. ${item.unidade}`}
                                </td>

                                {/* 2027 - Coluna Total estilizada como o cabeçalho */}
                                <td style={{ backgroundColor: '#6ab2ff', color: 'white' }}>
                                    {renderValue(item.turmas_27, item.turmas_26, true)}
                                </td>
                                <td style={styles.bg2027}>{renderValue(item.infantil_27, item.infantil_26)}</td>
                                <td style={styles.bg2027}>{renderValue(item.fund1_27, item.fund1_26)}</td>
                                <td style={styles.bg2027}>{renderValue(item.fund2_27, item.fund2_26)}</td>
                                <td style={styles.bg2027}>{renderValue(item.medio_27, item.medio_26)}</td>

                                {/* 2026 - Coluna Total estilizada como o cabeçalho */}
                                <td style={{ backgroundColor: '#ff7a87', color: 'white' }}>
                                    {renderValue(item.turmas_26, item.turmas_25, true)}
                                </td>
                                <td style={styles.bg2026}>{renderValue(item.infantil_26, item.infantil_25)}</td>
                                <td style={styles.bg2026}>{renderValue(item.fund1_26, item.fund1_25)}</td>
                                <td style={styles.bg2026}>{renderValue(item.fund2_26, item.fund2_25)}</td>
                                <td style={styles.bg2026}>{renderValue(item.medio_26, item.medio_25)}</td>

                                {/* 2025 - Coluna Total estilizada como o cabeçalho */}
                                <td style={styles.header2025} className="fw-bold">
                                    {item.turmas_25}
                                </td>
                                <td style={styles.bg2025}>{item.infantil_25}</td>
                                <td style={styles.bg2025}>{item.fund1_25}</td>
                                <td style={styles.bg2025}>{item.fund2_25}</td>
                                <td style={styles.bg2025}>{item.medio_25}</td>
                            </tr>
                        ))}
                    </tbody>
                    <tfoot className="fw-bolder border-top border-dark">
                        <tr className="bg-light">
                            <td className="text-start ps-3">TOTAL GERAL</td>
                            <td style={styles.header2027}>{totals.turmas_27}</td>
                            <td style={styles.bg2027}>{totals.infantil_27}</td>
                            <td style={styles.bg2027}>{totals.fund1_27}</td>
                            <td style={styles.bg2027}>{totals.fund2_27}</td>
                            <td style={styles.bg2027}>{totals.medio_27}</td>

                            <td style={styles.header2026}>{totals.turmas_26}</td>
                            <td style={styles.bg2026}>{totals.infantil_26}</td>
                            <td style={styles.bg2026}>{totals.fund1_26}</td>
                            <td style={styles.bg2026}>{totals.fund2_26}</td>
                            <td style={styles.bg2026}>{totals.medio_26}</td>

                            <td style={styles.header2025}>{totals.turmas_25}</td>
                            <td style={styles.bg2025}>{totals.infantil_25}</td>
                            <td style={styles.bg2025}>{totals.fund1_25}</td>
                            <td style={styles.bg2025}>{totals.fund2_25}</td>
                            <td style={styles.bg2025}>{totals.medio_25}</td>
                        </tr>
                    </tfoot>
                </Table>
            </div>
        </div>
    );
};

export default QTD_turmas;